import React from 'react';
import { Button, ButtonProps } from '@base/lib/Button';
import cn from 'classnames';
import styles from './index.module.less';

type IProps = ButtonProps;

export const OptionBtn = React.forwardRef<HTMLButtonElement, IProps>(({ children, className, ...props }, ref) => {
    return (
        <Button
            ref={ref}
            type={'no-style'}
            className={cn(styles['option-btn'], className)}
            {...props}
        >
            <div className={styles.bg}></div>
            <div className={styles.main}>{children}</div>
        </Button>
    )
});